import styled from 'styled-components';

export const Container = styled.div`
  width: 86%;
  border: 1px solid #E7E7E7;

  margin: 20px auto;

  display: flex;
  flex-direction: column;

  box-shadow: 0 4px 10px #00000020;
`;


export const Checkmark = styled.div`
  height: 16px;
  width: 16px;
  background-color: #fff;
  border-radius: 50%;
  position: relative;
  margin-right: 10px;
  border: 1px solid #707070;
  justify-content: center;
  align-items: center;
  display: flex;
`

export const CheckmarkInternalCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  box-shadow: 0px 0px 4px #00000022;
`

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  padding: 16px 12px;
  align-items: center;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  :not(:last-child) {
      border-bottom: 1px solid #E7E7E7;
  }

  &:hover {
    ${Checkmark} {
      background-color: #eee;
    }
  }
`;

// .multiselect-box {


//   label {
//       display: flex;
//       flex-direction: row;
//       font-size: 12px;
//       padding: 16px 12px;
//       align-items: center;
//       position: relative;
//       cursor: pointer;
//       -webkit-user-select: none;
//       -moz-user-select: none;
//       -ms-user-select: none;
//       user-select: none;

//       &:not(:last-child) {
//           border-bottom: 1px solid #E7E7E7;
//       }

//       /* Hide the browser's default radio button */
//       input {
//           position: absolute;
//           opacity: 0;
//           cursor: pointer;
//           height: 0;
//           width: 0;
//       }

//       /* Create a custom radio button */
//       .checkmark {
//           height: 16px;
//           width: 16px;
//           background-color: #fff;
//           border-radius: 50%;
//           position: relative;
//           margin-right: 10px;

//           border: 1px solid #707070;
//       }

//       /* On mouse-over, add a grey background color */
//       &:hover input ~ .checkmark {
//           background-color: #eee;
//       }

//       /* Create the indicator (the dot/circle - hidden when not checked) */
//       .checkmark:after {
//           content: "";
//           position: absolute;
//           display: none;
//       }

//       /* Show the indicator (dot/circle) when checked */
//       input:checked ~ .checkmark:after {
//           display: block;
//       }

//       /* Style the indicator (dot/circle) */
//       .checkmark:after {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           margin-top: -5px;
//           margin-left: -5px;
//           width: 10px;
//           height: 10px;
//           border-radius: 50%;
//           background: $primary;
//           box-shadow: 0px 0px 4px #00000022;
//       }
//   }
// }
